
import React from 'react';
import { Paper, Typography, Box, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Gradient } from '@mui/icons-material';

// BoardCard component displays information about a board and navigates to the board's card page when clicked
const BoardCard = ({ board }) => {
  const navigate = useNavigate(); // React Router hook for navigation

  // Function to handle card click, navigating to the specific card page using the board ID
  const handleCardClick = () => {
    navigate(`/card-page/${board.id}`);
  };

  return (
    <Tooltip
      title={
        <Box sx={{ maxWidth: 300 }}>
          <Typography variant="subtitle1"><strong>Board Name:</strong> {board.boardName}</Typography>
          <Typography variant="body2"><strong>Type:</strong> {board.boardType}</Typography>
          {/* <Typography variant="body2"><strong>Description:</strong> {board.boardDescription}</Typography>
          <Typography variant="body2"><strong>Project Title:</strong> {board.projectTitle}</Typography>
          <Typography variant="body2"><strong>Groups Assigned:</strong> {board.assignedGroups?.join(', ')}</Typography> */}
        </Box>
      }
      placement="top" // Tooltip appears above the card
      arrow // Adds an arrow pointing to the card
    >
      <Paper
        elevation={3} // Paper elevation level for shadow effect
        sx={{
          position: 'relative',         // Positioned relative for layering or inner element positioning
          padding: 2,                   // Padding inside the card
          margin: 0,                    // Margin set to zero for compact layout
          backgroundColor: '#FFFFF1',   // Light background color
          // backgroundColor: linear-gradient(45deg, #e0c3fc 0%, #8ec5fc 100%),
          backgroundColor: board.boardType === 'Sprint' ? '#FFF9C4' : '#f0f4ff',
          color: '#010405',             // Dark text color for contrast
          border: '1px solid #ced4da',  // Border for a subtle outline
          borderRadius: 8,              // Rounded corners
          boxShadow: '0 4px 10px rgba(0, 0, 0, 0.15)', // Initial shadow
          transition: 'transform 0.3s, box-shadow 0.3s', // Smooth animation for hover effects
          cursor: 'pointer',            // Pointer cursor to indicate clickability
          width: '100%',                // Full width within its container
          height: '300px',              // Fixed height for consistent card sizing
          '&:hover': {                  // Hover effect for interactive feedback
            transform: 'scale(1.03)',   // Slight scale-up effect on hover
            boxShadow: '0 8px 20px rgba(0, 0, 0, 0.25)', // Enhanced shadow on hover
          },
        }}
        onClick={handleCardClick} // Trigger navigation when the card is clicked
      >
        {/* Header section displaying board type */}
        <Box sx={{ backgroundColor: board.boardType === 'Sprint' ? '#5fc54aff' : '#007bff', borderRadius: 8, padding: 1 }}>
          <Typography
            variant="h6"
            sx={{
              fontSize: '1rem',          // Font size for the title text
              fontWeight: 'bold',        // Bold font for emphasis
              color: '#FFFFFF',          // White color for text contrast on the blue background
              textAlign: 'center',       // Centered text alignment
              overflow: 'hidden',        // Ensures long text doesn’t overflow
              textOverflow: 'ellipsis',  // Adds ellipsis for overflowing text
              whiteSpace: 'nowrap',      // Prevents text wrapping to new lines              
            }}
          >
            {/* {board.boardName} */}
            {board.boardType}
          </Typography>
        </Box>

        {/* Body section for additional board details */}
        <Box 
          sx={{ 
            flexGrow: 1, 
            display: 'flex', 
            flexDirection: 'column', 
            justifyContent: 'center', 
            alignItems: 'center',
            marginTop: '20px' 
          }}
        >
          <Typography 
            variant="body2" 
            sx={{ fontSize: '0.875rem', textAlign: 'center', mb: 0.5 }}
          >
            <strong>{board.boardName}</strong> {/* Displays the name of board */}
          </Typography>
        </Box>
      </Paper>
    </Tooltip>
  );
};

export default BoardCard;
